$(document).ready(function(){

    /* scroll to target */
   let scrollTrigger = $("*[scroll-trigger]");
   scrollTrigger.bind('click', function (e) {
     e.preventDefault();
     let _this = $(this);
     let triggerAttr = _this.attr('scroll-trigger');
     let scrollTarget = $('*[scroll-target=' + triggerAttr + ']');
 
     $('html, body').stop().animate({
       scrollTop: scrollTarget.offset().top - 70
     }, 600);
     return false;
   });
   // scroll to div js END here

    // js-pdc-uspa-slider start here
    if($('.js-pdc-uspa-slider').length > 0){
        $('.js-pdc-uspa-slider').slick({
            speed: 4000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: "linear",
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            arrows: false,
            dots: false,
            draggable: false,
            pauseOnHover: false,
            swipeToSlide: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                    slidesToShow: 3,
                    infinite:true,
                    }
                }
                ,
                {
                    breakpoint: 767,
                    settings: {
                    slidesToShow: 2,
                    infinite:true,
                    }
                }
            ]
        });
    }    
    // js-pdc-uspa-slider End here

    // js-pdc-dog-owners-slider Start here
    if($('.js-pdc-dog-owners-slider').length > 0){
        $('.js-pdc-dog-owners-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            dots: true,
            prevArrow: '<button class="slick-arrow slick-preview"><img src="https://puredogsco.com/cdn/shop/files/arrow-left.svg?v=1732612599&width=197" alt="arrow right" /></button>',
            nextArrow: '<button class="slick-arrow slick-next"><img src="https://puredogsco.com/cdn/shop/files/arrow-right.svg?v=1732612518&width=197" alt="arrow right" /></button>',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        arrows: false
                    }
                }
            ]
        });
    }
    // js-pdc-dog-owners-slider End here

    // js-pdc-testimonials-slider Start here
    if($('.js-pdc-testimonials-slider').length > 0){
        $('.js-pdc-testimonials-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            dots: true,
            prevArrow: '<button class="slick-arrow slick-preview"><img src="https://puredogsco.com/cdn/shop/files/arrow-left.svg?v=1732612599&width=197" alt="arrow right" /></button>',
            nextArrow: '<button class="slick-arrow slick-next"><img src="https://puredogsco.com/cdn/shop/files/arrow-right.svg?v=1732612518&width=197" alt="arrow right" /></button>',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        arrows: false
                    }
                }
            ]
        });
    }
    // js-pdc-testimonials-slider End here

    // Cutter js start here
    if($('.pdc-featured-articles__content .box .blog-title-text').length > 0){
        $('.pdc-featured-articles__content .box .blog-title-text').Cuttr({
            truncate: 'words',
            length: 4,
            readMore: false,
            ending: '...',
        });
    }
    // Cutter js end here


    // Ta Main Nav Slider Start Here
    if($('.js-choose-your-chews-main-slider').length > 0){
        $('.js-choose-your-chews-main-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            draggable: false,
            swipeToSlide: false,
            focusOnSelect: false,
            arrows: false,
            dots: false,
            asNavFor: '.js-choose-your-chews-nav-slider',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        draggable: false,
                        swipeToSlide: false,
                        focusOnSelect: false,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        draggable: false,
                        swipeToSlide: false,
                        focusOnSelect: false,
                    }
                }
            ]
        });
    }
    if($('.js-choose-your-chews-nav-slider').length > 0){
        $('.js-choose-your-chews-nav-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            swipeToSlide: false, 
            draggable: false,
            focusOnSelect: true,
            variableWidth: true,
            arrows: false,
            dots: false,
            asNavFor: '.js-choose-your-chews-main-slider',
        });
    }
    if($('.js-choose-your-chews-nav-slider').find('.item').length < 3){
        $('.js-choose-your-chews-nav-slider').addClass('less-items');
    } else{
        $('.js-choose-your-chews-nav-slider').removeClass('less-items');
    }
    // Ta Main Nav Slider End Here

    // js-review-profile-slider Start here
    if($('.js-review-profile-slider').length > 0){
        $('.js-review-profile-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true, 
            draggable: true,
            arrows: false,
            dots: true,
        });
    }
    // js-review-profile-slider End here
});